import React from 'react';
import {
  Users, DollarSign, FileText, TrendingUp, Calendar, Filter, Download, RefreshCw, CheckCircle, XCircle, Clock, Search, Mail, Phone, Building, CreditCard, Percent, AlertTriangle, Check, X, Edit2, Save, Wallet, Send, ArrowRight, Banknote, Bell, Trash2, Eye
} from 'lucide-react';
import { useSuperAdminContext } from '../SuperAdminContext';

export default function TransactionsTab() {
  const ctx = useSuperAdminContext();
  const { activeTab, allTransactions } = ctx;

  return (
    <>
            {activeTab === 'transactions' && (
              <div className="transactions-content">
                <div className="content-header">
                  <h2>All Transactions ({allTransactions.length})</h2>
                </div>

                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Session ID</th>
                        <th>User</th>
                        <th>Amount</th>
                        <th>Currency</th>
                        <th>Status</th>
                        <th>Created</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allTransactions.map((tx) => (
                        <tr key={tx.session_id}>
                          <td><code>{tx.session_id.substring(0, 12)}...</code></td>
                          <td>{tx.user_id?.substring(0, 8)}...</td>
                          <td>${tx.amount}</td>
                          <td>{tx.currency}</td>
                          <td>
                            <span className={`badge badge-${tx.payment_status}`}>
                              {tx.payment_status}
                            </span>
                          </td>
                          <td>{new Date(tx.created_at).toLocaleDateString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
    </>
  );
}
